/** Remnoves all special characters, hyphenates whitespace any non-standard characters
 * before putting it to lowercase  */
export const toKebabCase = (value: string) =>
  value
    ?.match(/[A-Z]{2,}(?=[A-Z][a-z0-9]*|\b)|[A-Z]?[a-z0-9]*|[A-Z]|[0-9]+/g)
    ?.filter(Boolean)
    .map((x) => x.toLowerCase())
    .join('-');

type ManipulateTextRequest = {
  value: string;
  replacements?: Record<string, string | number>;
};

export const manipulateText = ({
  value,
  replacements,
}: ManipulateTextRequest) => {
  let text = value;

  Object.entries(replacements ?? []).forEach((records) => {
    const delimiter = records[0];
    const regExp = new RegExp(delimiter, 'g');
    text = text?.replace(regExp, records[1].toString()) ?? '';
  });

  return text ?? '{{ContentNotFound}}';
};
